module.exports = __webpack_public_path__ + "static/media/27OCHA14.2cf9808b.jpg";